import React from 'react';
import SashiDo from 'lib/SashiDo';
import moment from 'moment';
import DashboardView from 'dashboard/DashboardView.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import PreLoader from 'components/PreLoader/PreLoader.react';
import HeatMap from './Requests/HeatMap.react';
import Graph from './Requests/Graph.react';

import settingsStyles               from 'dashboard/Settings/Settings.scss';
import styles from './Metrics.scss';

export default class Database extends DashboardView {
  constructor(props) {
    super(props);

    this.section = 'Metrics';
    this.subsection = 'Database';

    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    SashiDo.metricsDatabaseIndexStorage(this.props.currentApp.id).then((data) => {
      const { metrics } = data;

      const labels = [];
      const datasets = [];

      metrics.forEach((item) => {
        labels.push(item.timestamp);
        datasets.push(item.value || 0);
      });

      const result = metrics.reduce((r, a) => {
        const date = moment(a.timestamp).format('YYYY-MM');
        r[date] = r[date] || 0;
        r[date] = r[date] < a.value ? a.value : r[date];
        return r;
      }, {});

      this.state.databaseIndexStorageMetrics = {
        databaseIndexStorageOriginalData: metrics,
        last12Months: {
          labels: Object.keys(result),
          datasets: [
            {
              name: 'Index Storage',
              values: Object.keys(result).map(key => result[key]),
            }
          ]
        },
        last30Days: {
          labels: labels.slice(1).slice(-30),
          datasets: [
            {
              name: 'Index Storage',
              values: datasets.slice(1).slice(-30),
            }
          ]
        },
      }

      this.setState({
        loading: false,
      });
    });


    // DatabaseDatabase
    SashiDo.metricsDatabaseDataBaseStorage(this.props.currentApp.id).then((data) => {
      const { metrics } = data;

      const labels = [];
      const datasets = [];

      metrics.forEach((item) => {
        labels.push(item.timestamp);
        datasets.push(item.value || 0);
      });

      const result = metrics.reduce((r, a) => {
        const date = moment(a.timestamp).format('YYYY-MM');
        r[date] = r[date] || 0;
        r[date] = r[date] < a.value ? a.value : r[date];
        return r;
      }, {});

      this.state.databaseDataBaseStorageMetrics = {
        databaseDataBaseStorageOriginalData: metrics,
        last12Months: {
          labels: Object.keys(result),
          datasets: [
            {
              name: 'Database Storage',
              values: Object.keys(result).map(key => result[key]),
            }
          ]
        },
        last30Days: {
          labels: labels.slice(1).slice(-30),
          datasets: [
            {
              name: 'Database Storage',
              values: datasets.slice(1).slice(-30),
            }
          ]
        },
      }

      this.setState({
        loading: false,
      });
    });


    SashiDo.metricsDatabaseDocumentsStorage(this.props.currentApp.id).then((data) => {
      const { metrics } = data;

      const labels = [];
      const datasets = [];

      metrics.forEach((item) => {
        labels.push(item.timestamp);
        datasets.push(item.value || 0);
      });

      const result = metrics.reduce((r, a) => {
        const date = moment(a.timestamp).format('YYYY-MM');
        r[date] = r[date] || 0;
        r[date] = r[date] < a.value ? a.value : r[date];
        return r;
      }, {});

      this.state.databaseDocumentsStorageMetrics = {
        databaseDocumentsStorageOriginalData: metrics,
        last12Months: {
          labels: Object.keys(result),
          datasets: [
            {
              name: 'Data Storage',
              values: Object.keys(result).map(key => result[key]),
            }
          ]
        },
        last30Days: {
          labels: labels.slice(1).slice(-30),
          datasets: [
            {
              name: 'Data Storage',
              values: datasets.slice(1).slice(-30),
            }
          ]
        }
      }

      this.setState({
        loading: false,
      });
    });

    // Documents
    SashiDo.metricsDatabaseDocuments(this.props.currentApp.id).then((data) => {
      const { metrics } = data;

      const labels = [];
      const datasets = [];

      metrics.forEach((item) => {
        labels.push(item.timestamp);
        datasets.push(item.value || 0);
      });

      const result = metrics.reduce((r, a) => {
        const date = moment(a.timestamp).format('YYYY-MM');
        r[date] = r[date] || 0;
        r[date] = r[date] < a.value ? a.value : r[date];
        return r;
      }, {});

      this.state.databaseDocumentsMetrics = {
        databaseDocumentsOriginalData: metrics,
        last12Months: {
          labels: Object.keys(result),
          datasets: [
            {
              name: 'Documents',
              values: Object.keys(result).map(key => result[key]),
            }
          ]
        },
        last30Days: {
          labels: labels.slice(1).slice(-30),
          datasets: [
            {
              name: 'Documents',
              values: datasets.slice(1).slice(-30),
            }
          ]
        }
      }

      this.setState({
        loading: false,
      });
    });


    // Collections
    SashiDo.metricsDatabaseCollections(this.props.currentApp.id).then((data) => {
      const { metrics } = data;

      const labels = [];
      const datasets = [];

      metrics.forEach((item) => {
        labels.push(item.timestamp);
        datasets.push(item.value || 0);
      });

      const result = metrics.reduce((r, a) => {
        const date = moment(a.timestamp).format('YYYY-MM');
        r[date] = r[date] || 0;
        r[date] = r[date] < a.value ? a.value : r[date];
        return r;
      }, {});

      this.state.databaseCollectionsMetrics = {
        databaseCollectionsOriginalData: metrics,
        last12Months: {
          labels: Object.keys(result),
          datasets: [
            {
              name: 'Collections',
              values: Object.keys(result).map(key => result[key]),
            }
          ]
        },
        last30Days: {
          labels: labels.slice(1).slice(-30),
          datasets: [
            {
              name: 'Collections',
              values: datasets.slice(1).slice(-30),
            }
          ]
        }
      }

      this.setState({
        loading: false,
      });
    });

    // Indexes
    SashiDo.metricsDatabaseIndexes(this.props.currentApp.id).then((data) => {
      const { metrics } = data;

      const labels = [];
      const datasets = [];

      metrics.forEach((item) => {
        labels.push(item.timestamp);
        datasets.push(item.value || 0);
      });

      const result = metrics.reduce((r, a) => {
        const date = moment(a.timestamp).format('YYYY-MM');
        r[date] = r[date] || 0;
        r[date] = r[date] < a.value ? a.value : r[date];
        return r;
      }, {});

      this.state.databaseIndexesMetrics = {
        databaseIndexesOriginalData: metrics,
        last12Months: {
          labels: Object.keys(result),
          datasets: [
            {
              name: 'Indexes',
              values: Object.keys(result).map(key => result[key]),
            }
          ]
        },
        last30Days: {
          labels: labels.slice(1).slice(-30),
          datasets: [
            {
              name: 'Indexes',
              values: datasets.slice(1).slice(-30),
            }
          ]
        }
      }

      this.setState({
        loading: false,
      });
    });


    // Avg. Document Size
    SashiDo.metricsDatabaseAvgDocumentSize(this.props.currentApp.id).then((data) => {
      const { metrics } = data;

      const labels = [];
      const datasets = [];

      metrics.forEach((item) => {
        labels.push(item.timestamp);
        datasets.push(item.value || 0);
      });

      const counts = {};
      const result = metrics.reduce((r, a) => {
        const date = moment(a.timestamp).format('YYYY-MM');

        // count months days
        counts[date] = (counts[date] || 0)+1;

        r[date] = r[date] || 0;
        r[date] += a.value || 0;

        return r;
      }, {});

      this.state.databaseAvgDocumentSizeMetrics = {
        AvgDocumentSizeOriginalData: metrics,
        last12Months: {
          labels: Object.keys(result),
          datasets: [
            {
              name: 'Database Avg. Size',
              values: Object.keys(result).map(key => result[key]/counts[key]),
            }
          ]
        },
        last30Days: {
          labels: labels.slice(1).slice(-30),
          datasets: [
            {
              name: 'Database Avg. Size',
              values: datasets.slice(1).slice(-30),
            }
          ]
        }
      }

      this.setState({
        loading: false,
      });
    });
  }

  renderContent() {
    const { props } = this;
    const {
      heatMapData,
      databaseIndexStorageMetrics,
      databaseDataBaseStorageMetrics,
      databaseDocumentsStorageMetrics,
      databaseDocumentsMetrics,
      databaseCollectionsMetrics,
      databaseIndexesMetrics,
      databaseAvgDocumentSizeMetrics,
    } = this.state;


    const classes = [settingsStyles.settings_page, settingsStyles.default];

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.section} subsection={this.subsection} />
        <PreLoader loading={this.state.loading}>
          <div className={settingsStyles.holder}>
            <div className={[styles.holder, styles.withTopPadding].join(' ')}>
              {
                databaseDataBaseStorageMetrics &&
                  <Graph
                    {...props}
                    data={databaseDataBaseStorageMetrics}
                    title='Total Storage'
                    tooltip='Total amount of uncompressed Documents + Indexes storage. Collecting since Aug 20 2016 and updating every 8 hours.'
                    unit=''
                    dataFormat='0.[00] b'
                    toolTipDataFormat='0.[00] b'
                    colors={['#98d85b']} />
              }

              <div className={styles.separator} />

              {
                databaseDocumentsMetrics &&
                  <Graph
                    {...props}
                    data={databaseDocumentsMetrics}
                    title='Total Documents'
                    tooltip='Total count of the Documents in all the application collections/classes. Collecting since Jul 01 2018 and updating every 8 hours.'
                    unit=''
                    dataFormat='0.[0] a'
                    colors={['#98d85b']} />
              }

              <div className={styles.separator} />

              {
                databaseCollectionsMetrics &&
                  <Graph
                    {...props}
                    data={databaseCollectionsMetrics}
                    title='Total Collections'
                    tooltip='Total count of the Collections in your application database. Collecting since Jul 01 2018 and updating every 8 hours.'
                    unit=''
                    dataFormat='0.[0] a'
                    colors={['#98d85b']} />
              }

              <div className={styles.separator} />

              {
                databaseIndexesMetrics &&
                  <Graph
                    {...props}
                    data={databaseIndexesMetrics}
                    title='Total Indexes'
                    tooltip='Total count of the Indexes in your application database. Collecting since Jul 01 2018 and updating every 8 hours.'
                    unit=''
                    dataFormat='0.[0] a'
                    colors={['#98d85b']} />
              }

              <div className={styles.separator} />

              {
                databaseAvgDocumentSizeMetrics &&
                  <Graph
                    {...props}
                    data={databaseAvgDocumentSizeMetrics}
                    title='Average Document Size'
                    tooltip='This is the average size of a document in your application database. Collecting since Jul 01 2018 and updating every 8 hours.'
                    unit=''
                    dataFormat='0.[00] b'
                    toolTipDataFormat='0.[00] b'
                    colors={['#98d85b']} />
              }

              <div className={styles.separator} />

              {
                databaseDocumentsStorageMetrics &&
                  <Graph
                    {...props}
                    data={databaseDocumentsStorageMetrics}
                    title='Total Documents Storage'
                    tooltip='Total amount of uncompressed Documents Storage in your application database. Collecting since Jul 01 2018 and updating every 8 hours.'
                    unit=''
                    dataFormat='0.[00] b'
                    toolTipDataFormat='0.[00] b'
                    colors={['#98d85b']} />
              }

              <div className={styles.separator} />

              {
                databaseIndexStorageMetrics &&
                  <Graph
                    {...props}
                    data={databaseIndexStorageMetrics}
                    title='Total Indexes Storage'
                    tooltip='Total amount of uncompressed Indexes Storage in your application database. Collecting since Jul 01 2018 and updating every 8 hours.'
                    unit=''
                    dataFormat='0.[00] b'
                    toolTipDataFormat='0.[00] b'
                    colors={['#98d85b']} />
              }
            </div>
          </div>
        </PreLoader>
      </div>
    );
  }
}
